export default __webpack_public_path__ + "static/media/banner-hpc.0febb128.png";